export const Offices = (props) => {
  const offices = props.data || []

  return (
    <div id='offices' className='text-center'>
      <div className='container'>
        <div className='row'>
          <div className='col-md-10 col-md-offset-1 section-title'>
            <h2>Our Offices</h2>
            <p>Serving communities across India with {offices.length} regional offices. Walk in or call us — we are always close by.</p>
          </div>
        </div>
        <div className='row flex-card-row'>
          {offices.map((o, i) => (
            <div key={i} className='col-md-4 col-sm-6 col-xs-12 flex-card-col'>
              <div className='office-card'>
                <div className='office-card-header'>
                  <i className='fa fa-map-marker office-city-icon'></i>
                  <h3 className='office-city'>{o.city}</h3>
                </div>
                <div className='office-map'>
                  <iframe
                    title={`Map – ${o.city}`}
                    src={o.mapEmbedUrl}
                    width='100%'
                    height='180'
                    frameBorder='0'
                    style={{ border: 0 }}
                    allowFullScreen=''
                    loading='lazy'
                    referrerPolicy='no-referrer-when-downgrade'
                  ></iframe>
                </div>
                <div className='office-info'>
                  <p className='office-address'>
                    <i className='fa fa-map-marker'></i> {o.address}
                  </p>
                  <p className='office-phone'>
                    <i className='fa fa-phone'></i>
                    <a href={`tel:${o.phone.replace(/\s/g, '')}`}>{o.phone}</a>
                  </p>
                  {o.googleRating && (
                    <div className='office-rating'>
                      <i className='fa fa-star office-rating-star'></i>
                      <span className='office-rating-score'>{o.googleRating}</span>
                      <span className='office-rating-count'>({o.reviewCount} Google reviews)</span>
                    </div>
                  )}
                  <a
                    href={o.googleMapsLink}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='btn btn-office-map'
                  >
                    <i className='fa fa-google'></i> View on Google Maps
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

